import "core-js/modules/es.array.reduce.js";
import { keys } from '../util';
import { wrapCondition } from './mark/mixins';
export function guideEncodeEntry(encoding, model) {
  return keys(encoding).reduce(function (encode, channel) {
    var valueDef = encoding[channel];
    return Object.assign({}, encode, wrapCondition(model, valueDef, channel, function (x) {
      return {
        value: x.value
      };
    }));
  }, {});
}